const DATA_SAVED = "extragestor/colegios/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/colegios/RESET_DATA_SAVED";
const FETCH = "extragestor/colegios/FETCH";
const FETCH_DETALLE = "extragestor/colegios/FETCH_DETALLE";
const RESET_DETALLE = "extragestor/colegios/RESET_DETALLE";
const REMOVED = "extragestor/colegios/REMOVED";
const RESET = "extragestor/colegios/RESET";
const FETCH_SEARCHDATA = "extragestor/colegios/FETCH_SEARCHDATA";
const RESET_SEARCHDATA = "extragestor/colegios/RESET_SEARCHDATA";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  FETCH,
  REMOVED,
  RESET,
  FETCH_DETALLE,
  FETCH_SEARCHDATA,
  RESET_SEARCHDATA,
  RESET_DETALLE
};



// WEBPACK FOOTER //
// ./src/ducks/colegios/types.js